// "You don't have access to this document yet": what an editor shows for a
// 403/404 instead of the raw error. Access is often on its way (a share being
// granted), so it offers to check again — unless docs-api said the person's
// access in docs opens no documents at all (`reason` missing_scope: no
// `files:read`; guests_not_allowed: a guest signer), which a share won't fix.

import { useTranslation } from 'react-i18next';
import { Lock, RefreshCw } from 'lucide-react';

const BY_SCOPE = new Set(['missing_scope', 'guests_not_allowed']);

export function EditorNoAccess({ onRetry, reason = null }) {
  const { t } = useTranslation('editor');
  const byScope = BY_SCOPE.has(reason);
  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center gap-3 p-6 text-center" data-testid="editor-no-access">
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-muted">
        <Lock className="h-5 w-5 text-muted-foreground" />
      </span>
      <p className="text-sm font-semibold text-foreground">{t('noAccess.title')}</p>
      <p className="max-w-sm text-xs text-muted-foreground">{t(byScope ? 'noAccess.scopeHint' : 'noAccess.hint')}</p>
      {onRetry && !byScope && (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 rounded-md border border-border px-3 py-1.5 text-xs font-medium hover:bg-muted cursor-pointer"
        >
          <RefreshCw className="h-3.5 w-3.5" /> {t('noAccess.retry')}
        </button>
      )}
    </div>
  );
}
